/**
 * Devuelve clases Tailwind de color de fondo y texto para un estado de invitacion
 * @param {string} estado
 * @returns {{ bg: string, text: string, label: string }}
 */
export function getColorByEstadoInvitacion(estado) {
  const mapa = {
    pendiente: {
      bg: "bg-yellow-500",
      text: "text-yellow-500",
      badge: "bg-yellow-500/90 text-aw-bluedark border border-yellow-700",
      label: "Pendiente",
    },
    aceptada_gratis: {
      bg: "bg-aw-green",
      text: "text-aw-green",
      badge: "bg-aw-green/90 text-aw-bluedark border border-aw-green/40",
      label: "Aceptada Gratis",
    },
    aceptada_descuento: {
      bg: "bg-aw-green",
      text: "text-aw-green",
      badge: "bg-aw-green/90 text-aw-bluedark border border-aw-green/40",
      label: "Aceptada con Descuento",
    },
    aceptada_pago_total: {
      bg: "bg-aw-green",
      text: "text-aw-green",
      badge: "bg-aw-green/90 text-aw-bluedark border border-aw-green/40",
      label: "Aceptada (Pago Total)",
    },
    aceptada_gratis_total: {
      bg: "bg-aw-green",
      text: "text-aw-green",
      badge: "bg-aw-green/90 text-aw-bluedark border border-aw-green/40",
      label: "Aceptada Totalmente Gratis",
    },
    rechazada: {
      bg: "bg-red-600",
      text: "text-red-500",
      badge: "bg-red-600/90 text-white border border-red-500/40",
      label: "Rechazada",
    },
    pago_pendiente: {
      bg: "bg-orange-500",
      text: "text-orange-500",
      badge: "bg-orange-400/90 text-aw-bluedark border border-orange-500/40",
      label: "Pago Pendiente",
    },
    pagada: {
      bg: "bg-blue-500",
      text: "text-blue-400",
      badge: "bg-blue-600/90 text-white border border-blue-500/40",
      label: "Pagada",
    },
    entrada_exitosa: {
      bg: "bg-teal-600",
      text: "text-teal-400",
      badge: "bg-teal-600/90 text-white border border-teal-500/40",
      label: "Entrada Exitosa",
    },
  };

  return (
    mapa[estado] || {
      bg: "bg-gray-500",
      text: "text-gray-400",
      badge: "bg-gray-600/90 text-white border border-gray-500/40",
      label: estado || "Postulando",
    }
  );
}
